import { render } from "./nodisclosure.vue?vue&type=template&id=d6d96d80"
import script from "./nodisclosure.vue?vue&type=script&lang=js"
export * from "./nodisclosure.vue?vue&type=script&lang=js"

import "./nodisclosure.vue?vue&type=style&index=0&id=d6d96d80&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/nodisclosure.vue'],['render',render],['__file',"nodisclosure.vue"]])

export default __exports__